import { InboxOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, InputNumber, Row, Select, Typography, Upload } from "antd";
import React, { Fragment, useEffect, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addExpenseForm } from "../../redux/rtk/features/expense/expenseSlice";
import { getAllExpenseProject } from "../../redux/rtk/features/expenseProject/expenseProjectSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const { Dragger } = Upload;

const AddExpense = ({ drawer }) => {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const id = getUserFromToken();

  const { Title } = Typography;
  const [form] = Form.useForm();
	const [thumbFileList, setThumbFileList] = useState([]);
  const [expenseEntries, setExpenseEntries] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [editMode, setEditMode] = useState(false);
  const projects = useSelector(state => state?.expenseProject?.list);

  useEffect(() => {
		dispatch(getAllExpenseProject());
	}, []);

  const onFinish = async (values) => {
  const expenseData = {
    ...values,
    userId: id,
    projectId: values.projectName,
    expenseTitle:values.expenseTitle,
    expenseAmount: values.expenseAmount,
    expenseDate: values.expenseDate.format(),
    expenseProof: thumbFileList[0]?.originFileObj,
    key: Date.now(),
  };
  console.log("expense data>", expenseData)
  const resp = await dispatch(addExpenseForm(expenseData));
  
  if (resp.payload.message === 'success') {
    setLoader(false);
    setExpenseEntries([]);
    toast.success('Expenses submitted successfully');
    setEditMode(false);
  } else {
    setLoader(false);
    toast.error('Failed to submit expenses');
  }

  
  if (editMode) {
    const updatedEntries = expenseEntries.map((entry) => {
      if (entry.key === editingKey) {
        return expenseData;
      }
      return entry;
    });
    setExpenseEntries(updatedEntries);
    setEditMode(false);
  } else {
    setExpenseEntries([...expenseEntries, expenseData]);
  }

  form.resetFields();
  setThumbFileList([]);
};


  const onFinishFailed = (errorInfo) => {
		setLoader(false);
    toast.warning("Failed to add expense");
		console.log("Failed:", errorInfo);
  };

  const handleFileUpload = ({ fileList }) => {
    console.log("fileList",fileList)
    setThumbFileList(fileList);
  };

    // const handleSubmit = async () => {
    //   setLoader(true);

    //   const promises = expenseEntries.map(async (entry) => {
    //     if (entry.expenseProof instanceof File) {
    //       const base64 = await fileToBase64(entry.expenseProof);
    //       return {
    //         ...entry,
    //         expenseProof: base64,
    //       };
    //     }
    //     return entry;
    //   });

    //   const updatedEntries = await Promise.all(promises);

    //   const resp = await dispatch(addExpenseForm(updatedEntries));

    //   if (resp.payload.message === 'success') {
    //     setLoader(false);
    //     setExpenseEntries([]);
    //     toast.success('Expenses submitted successfully');
    //     setEditMode(false);
    //   } else {
    //     setLoader(false);
    //     toast.error('Failed to submit expenses');
    //   }
    // };

    // const columns = [
    //   {
    //     title: "Expense Title",
    //     dataIndex: "expenseTitle",
    //     key: "expenseTitle",
    //     editable: true,
    //   },
    //   {
    //     title: "Amount",
    //     dataIndex: "expenseAmount",
    //     key: "expenseAmount",
    //     editable: true,
    //   },
    //   {
    //     title: "Date",
    //     dataIndex: "expenseDate",
    //     key: "expenseDate",
    //     render: (text) => moment(text).format("DD-MM-YYYY"),
    //   },
    //   {
    //     title: "File Name",
    //     dataIndex: "expenseProof",
    //     key: "expenseProof",
    //     render: (proof) => proof?.fileName,
    //   },
    //   {
    //     title: "Actions",
    //     dataIndex: "actions",
    //     render: (_, record) => (
    //       <div style={{ display: "flex" }}>
    //         <Button
    //           style={{ marginRight: 8 }}
    //           onClick={() => edit(record, record.key)}
    //           icon={<EditOutlined />}
    //         />
    //         <Popconfirm
    //           title="Are you sure to delete this expense?"
    //           onConfirm={() => handleDelete(record.key)}
    //           okText="Yes"
    //           cancelText="No"
    //         >
    //           <Button
    //             type="danger"
    //             icon={<DeleteOutlined />}
    //           />
    //         </Popconfirm>
    //       </div>
    //     ),
    //   },

    // ];


    // const totalAmount = expenseEntries.reduce(
    //   (total, entry) => total + entry.expenseAmount,
    //   0
    // );

    // // const isEditing = (record) => record.key === editingKey;
    // const isEditing = (record) => record.key === editingKey && editingKey !== "";


    // const edit = (record,key) => {
    //   form.setFieldsValue({
    //     ...record,
    //     expenseDate: moment(record.expenseDate), // Convert to moment.js object
    //     expenseProof: undefined, // Reset the file upload field
    //   });
    //   setEditingKey(record.key);
    //   // setFileList([{ name: record.expenseProof.fileName, uid: record.key, status: 'done', originFileObj: record.expenseProof.file }]);
    //   setEditMode(true);
    // };

    // const cancel = () => {
    //   setEditingKey("");
    // };

    //  const handleDelete = (key) => {
    //   console.log("key>>>", key)
    //   const newData = expenseEntries.filter((item) => item.key !== key);
    //   setExpenseEntries(newData);
    // };


    return (
      <Fragment bordered={false}>
        <UserPrivateComponent permission={"create-leaveApplication"}>
          <Row className="mr-top" justify={drawer ? "center" : "center"}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={drawer ? 22 : 16}
              xl={drawer ? 22 : 12}
              className="column-design border rounded card-custom"
            >
              <Title level={4} className="m-2 mt-5 mb-5 text-center">
                Add Expense
              </Title>
              <Form
                form={form}
                style={{ marginBottom: "40px" }}
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 12,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                style={{ marginBottom: "10px" }}
                label="Select Project"
                name="projectName"
                rules={[
                  {
                    required: true,
                    message: "Please select a project",
                  },
                ]}
              >
                <Select placeholder="Select a project">
                  {(projects || []).map((project) => (
                    <Select.Option key={project.id} value={project.id}>
                      {project.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Expense Title"
                  name="expenseTitle"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the expense title",
                    },
                  ]}
                >
                  <Input  placeholder="Enter Expense Title"/>
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Amount"
                  name="expenseAmount"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the expense amount",
                    },
                    
                  ]}
                >
                  <InputNumber  placeholder="Enter amount"/>

                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Date"
                  name="expenseDate"
                  rules={[
                    {
                      required: true,
                      message: "Please select the expense date",
                    },
                  ]}
                >
                  <DatePicker />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Proof File"
                  // name="expenseProof"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please upload a proof file",
                  //   },
                  // ]}
                  required={false}
                >
                  <Dragger
                    listType='picture-card'
                    beforeUpload={() => false}
                    name='expenseProof'
                    fileList={thumbFileList}
                    onChange={handleFileUpload}
                    maxCount={1}
                  // showUploadList={{
                  //   showRemoveIcon: true,
                  // }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    {/* <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p> */}
                    <p className="ant-upload-hint">
                      Support for a single upload. Strictly prohibited from uploading
                      company data or other banned files.
                    </p>
                  </Dragger>
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 6,
                    span: 12,
                  }}
                >
                  <Button type="primary" size="large" htmlType="submit" block>
                    {editMode ? "Update Expense" : "Add Expense"}
                  </Button>
                </Form.Item>
              </Form>

              {/* <Table
              dataSource={expenseEntries}
              columns={columns}
              pagination={false}
              summary={(pageData) => (
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={2}>Total Amount</Table.Summary.Cell>
                  <Table.Summary.Cell>₹{totalAmount}</Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            /> */}

              {/* <Button
              onClick={handleSubmit}
              type="primary"
              size="large"
              block
              loading={loader}
              disabled={expenseEntries.length === 0}
            >
              Submit Expenses
            </Button> */}
            </Col>
          </Row>
        </UserPrivateComponent>
      </Fragment>
    );
  };


  export default AddExpense; 